import * as React from 'react';
import { Box, Stack, Typography, Dialog } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as JSTool from '../store/JSTool';
import { settingActions } from '../store/SettingSlice';
import $ from 'jquery';
import * as APJHttp from '../store/APJHttp';


export default function SubmitEmailAlert(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function closeTap() {
        dispatch(settingActions.showRegisterAlert(false));
    }

    return (
        <Dialog
            fullScreen={true}
            PaperProps={{
                style: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#00000099',
                    boxShadow: 'none',
                    padding: 0,
                    margin: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                },
            }}
            open={settingData.showRegisterAlert}>

            <Stack sx={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: settingData.isMobile ? 1 : '650rem',
            }}>
                <Box
                    component={'img'}
                    onClick={closeTap}
                    src={JSTool.getImgPath('ico-close-w.png')}
                    sx={{
                        alignSelf: 'flex-end',
                        cursor: 'pointer',
                        width: '20rem',
                        mr: 2,
                        mb: 2,
                        zIndex: 10,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'rotate(180deg)',
                        }
                    }} />

                {!settingData.submitedEmail && <EmailContainer />}
                {settingData.submitedEmail && <EmailSuccess />}


            </Stack>

        </Dialog>
    );
}

function EmailContainer() {

    const dispatch = useDispatch();
    const [checked, setChecked] = React.useState(true);
    const settingData = useSelector(state => state.settingData);

    const [count, setCount] = React.useState(0);
    let timer = null;

    function checkTap() {
        setChecked((oldState) => {
            return !oldState;
        });
    }

    function sendTap() {
        if (count > 0) {
            return;
        }

        const e0 = $('#input_one')[0].value;
        if (!JSTool.isEmail(e0)) {
            dispatch(settingActions.showToast('Please enter a valid E-mail address'));
            return
        }

        dispatch(settingActions.showLoading(true));
        APJHttp.sendEmailCode(e0, (data) => {
            dispatch(settingActions.showLoading(false));
            startTimer();

        }, (code, msg) => {
            stopTimer();
            requestError(code, msg);
        })
    }

    function startTimer() {
        stopTimer();
        setCount(120);
        timer = setInterval(() => { tick() }, 1000);
    }

    function tick() {
        setCount(v => {
            let x = v - 1;
            if (x > 0) {
                setCount(x);
            } else {
                stopTimer();
            }
            return x;
        });
    }

    function stopTimer() {
        if (timer != null) {
            clearInterval(timer);
            timer = null;
            setCount(0);
        }
    }


    function submitTap() {
        const e0 = $('#input_one')[0].value;
        // const e1 = $('#input_two')[0].value;

        if (!JSTool.isEmail(e0)) {
            dispatch(settingActions.showToast('Please enter a valid E-mail address'));
            return
        }

        // if (JSTool.isEmpty(e1)) {
        //     dispatch(settingActions.showToast('Please enter the verification code'));
        //     return;
        // }

        // if (!checked) {
        //     dispatch(settingActions.showToast('Please agree the protocol'));
        //     return;
        // }

        //提交网络请求
        JSTool.trackEvent('email_submit');
        dispatch(settingActions.showLoading(true));
        APJHttp.addEmail_noCode(e0, (data) => {
            dispatch(settingActions.showLoading(false));
            dispatch(settingActions.setSubmitedEmail(e0));
            stopTimer();
        }, (code, msg) => {
            requestError(code, msg);
        })
    }

    // MailErrorExisted        = 404001 邮箱已存在
    // MailErrorSendCode       = 404002 邮件发送失败
    // MailErrorNoRedisRecord  = 404003 请先发送验证码或者已过期
    // MailErrorWrongCode      = 404004 验证码不对
    // MailErrorInsertDatabase = 404005 数据插入失败
    function requestError(code, msg) {
        dispatch(settingActions.showLoading(false));
        if (code == 404001) {
            dispatch(settingActions.showToast(`${code}: E-mail already exists`));
        } else if (code == 404002) {
            dispatch(settingActions.showToast(`${code}: Mail sending failed`));
        } else if (code == 404003) {
            dispatch(settingActions.showToast(`${code}: Please send a verification code or it has expired`));
        } else if (code == 404004) {
            dispatch(settingActions.showToast(`${code}: The verification code is incorrect`));
        } else {
            dispatch(settingActions.showToast(`${code}: Request failed, please try again later`));
        }
    }

    function checkTap() {
        setChecked((oldState) => {
            return !oldState;
        });
    }

    return (
        <Stack sx={{
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            width:1,
        }}>

            <Box component={'img'}
                src={JSTool.getImgPath('email_girl.png')}
                sx={{
                    position: 'absolute',
                    width: settingData.isMobile ? 0.7 : '500rem',
                    zIndex: 1,
                    top: settingData.isMobile ? 10 : -50,
                }} />

            <Stack sx={{
                width: settingData.isMobile ? 0.85 : '550rem',
                bottom: 0,
                alignItems: 'center',
                backgroundImage: `url(${JSTool.getImgPath('email_bg.png')})`,
                backgroundSize: '100% 100%',
                py: 4,
                px: settingData.isMobile ? 3 : 6,
                alignContent: 'center',
                mt: settingData.isMobile ? '250rem' : '260rem',
                zIndex: 10,
                bgcolor: 'black'
            }}>

                <Stack sx={{
                    zIndex: 2,
                    bgcolor: 'white',
                    height: '38rem',
                    width: 1,
                    flexDirection: 'row',
                    border: 1,
                    borderColor: 'white',
                }}>
                    <Typography sx={{
                        width: '250rem',
                        height: 1,
                        bgcolor: '#9D7F5B',
                        fontSize: settingData.isMobile ? '13rem' : '14rem',
                        color: 'white',
                        textAlign: 'left',
                        lineHeight: '38rem',
                        pl: 1.5,
                        fontFamily: window.font0
                    }}>
                        Please enter your e-mail:
                    </Typography>

                    <Stack
                        id='input_one'
                        component={'input'}
                        type={'email'}
                        placeholder={''}
                        sx={{
                            fontFamily: window.font0,
                            flex: 1,
                            px: 2,
                            width:  settingData.isMobile && '220rem',
                            fontSize: '16rem',
                            border: 0,
                            outline: 'none',
                            color: 'black',
                            '&::placeholder': {
                                color: "gray",
                                fontFamily: '-moz-initial',
                            },
                        }} />

                </Stack>

                <Stack sx={{
                    display: 'none',
                    zIndex: 2,
                    mt: settingData.isMobile ? 0.5 : 1,
                    bgcolor: 'white',
                    height: '38rem',
                    width: '1',
                    flexDirection: 'row',
                    border: 1,
                    borderColor: 'white',
                }}>

                    <Typography sx={{
                        width: '250rem',
                        height: 1,
                        bgcolor: '#9D7F5B',
                        fontSize: settingData.isMobile ? '13rem' : '14rem',
                        color: 'white',
                        textAlign: 'left',
                        lineHeight: '38rem',
                        pl: 1.5,
                        fontFamily: window.font0,
                    }}>
                        {settingData.isMobile ?  'Please enter the code:' : 'Please enter the verification code:'}
                    </Typography>

                    <Stack sx={{
                        flex: 1,
                        flexDirection: 'row',
                        position: 'relative',
                    }}>
                        <Stack
                            id='input_two'
                            component={'input'}
                            type={'email'}
                            placeholder={''}
                            sx={{
                                fontFamily: window.font0,
                                px: 2,
                                flex: 1,
                                width:  settingData.isMobile && '220rem',
                                fontSize: '16rem',
                                border: 0,
                                outline: 'none',
                                color: 'black',
                                '&::placeholder': {
                                    color: "gray",
                                    fontFamily: '-moz-initial',
                                },
                            }} />

                        <Typography
                            onClick={sendTap}
                            sx={{
                                fontFamily: window.font0,
                                width: '100rem',
                                height: '35rem',
                                lineHeight: '35rem',
                                bgcolor: count > 0 ? 'lightgray' : '#9D7F5B',
                                fontSize: '14rem',
                                color: 'white',
                                textAlign: 'center',
                                borderRadius: '30rem',
                                position: 'absolute',
                                right: '5rem',
                                top: '2.5rem',
                                cursor: count <= 0 && 'pointer',
                            }}>
                            {count > 0 ? `${count}s` : 'Get Code'}
                        </Typography>


                    </Stack>

                </Stack>


                <Stack sx={{
                    zIndex: 2,
                    mt: 1,
                    bgcolor: 'white',
                    width: '1',
                    position: 'relative',
                }}>

                    <Box
                        component={'div'}
                        sx={{
                            bgcolor: 'white',
                            fontSize: '11rem',
                            color: 'black',
                            fontWeight: 'bold',
                            textAlign: 'left',
                            lineHeight: '20rem',
                            pl: '10rem',
                            py: 1,
                            fontFamily: window.font0,
                        }}
                        dangerouslySetInnerHTML={{
                            __html:
                                `

Stay informed about all the latest updates on Blue Protocol: Star Resonance! 
                                  
                         `
                        }} />

                    <Box component={'img'}
                        onClick={checkTap}
                        src={checked ? JSTool.getImgPath('checked1.png') : JSTool.getImgPath('uncheck.png')}
                        sx={{
                            width: '19rem',
                            position: 'absolute',
                            left: '10rem',
                            top: '10rem',
                            cursor: 'pointer',
                            display: 'none'
                        }} />

                </Stack>

                <Typography
                    onClick={submitTap}
                    sx={{
                        zIndex: 2,
                        mt: 2,
                        width: '120rem',
                        height: '40rem',
                        fontSize: '16rem',
                        color: 'white',
                        textAlign: 'center',
                        lineHeight: '40rem',
                        pl: 1,
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontFamily: window.font0,
                        backgroundImage: `url(${JSTool.getImgPath('email_submit_bg.png')})`,
                        backgroundSize: '100% 100%',
                    }}>
                    Submit
                </Typography>
            </Stack>
        </Stack>
    );
}


function EmailSuccess(props) {

    const settingData = useSelector(state => state.settingData);

    return (
        <Typography sx={{
            fontSize: settingData.isMobile ? '16rem' : '22rem',
            fontWeight: 'bold',
            color: 'black',
            backgroundImage: `url(${JSTool.getImgPath('email_bg.png')})`,
            backgroundSize: '100% 100%',
            px: 2,
            py: 10,
            width: 1,
            width: settingData.isMobile ? 0.8 : '550rem',
        }}>
            You have successfully submitted the Email !
        </Typography>
    );


}
